module Meevo.Plugins.SystemToolbox {
    export class SelectMultiLocationModalController {
        filteredLocationIdList: number[] = [];
        availableLocationsList: any[] = [];
        context: any;

        static $inject = [
            '$filter',
            'meevo.components.modal.ModalService',
            'multiLocationList'
        ];

        constructor(
            protected $filter: angular.IFilterService,
            private modalService: Meevo.Components.Modal.IModalService,
            multiLocationList: Meevo.Model.Location[]
        ) {
            this.context = {
                selectedSection: {
                    model: {
                        businessTypeDetail: {},
                        locationOverride: {},
                    }
                }
            };

            this.filteredLocationIdList = _(multiLocationList).pluck('id');
        }

        // this method is discovered and used by multiLocationPicker.ts through scope.vm
        postProcessLocations = (locations) => {
            this.availableLocationsList = locations.filter((location) => this.filteredLocationIdList.indexOf(location.id) !== -1);
            return this.availableLocationsList;
        };

        apply(excludedLocations: any[]) {
            if (excludedLocations.length === this.availableLocationsList.length) {
                this.close('excluded');
                return;
            }

            const availableLocationIdList = _(this.availableLocationsList).pluck('id');
            const excludedLocationIdList = _(excludedLocations).pluck('id');
            const includedLocationIdList = availableLocationIdList.filter((id: number) => excludedLocationIdList.indexOf(id) === -1);

            this.close(includedLocationIdList);
        }

        close(response) {
            this.modalService.hideWithResponse(response);
        }

        cancel() {
            this.close(null);
        }
    }

    angular.module("meevo.plugins.systemToolbox")
        .controller("meevo.plugins.systemToolbox.SelectMultiLocationModalController", SelectMultiLocationModalController);
}
